var _rect, _path, _path2, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUyu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2757_5856",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2757_5856)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "#F7FCFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2757_5856",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2757_5856)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 3.8335,
    width: 23,
    height: 1.91667,
    fill: "#2E42A5"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 7.6665,
    width: 23,
    height: 1.91667,
    fill: "#2E42A5"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 11.5,
    width: 23,
    height: 1.91667,
    fill: "#2E42A5"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 15.3335,
    width: 23,
    height: 1.91667,
    fill: "#2E42A5"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 19.1665,
    width: 23,
    height: 1.91667,
    fill: "#2E42A5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.5,
    height: 13.4167,
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.63227 10.5771C6.63227 10.5771 5.89778 12.6076 5.25224 13.0239C5.53088 12.0926 5.63344 10.1925 5.63344 10.1925C5.63344 10.1925 3.95738 11.0785 3.3691 10.917C4.07648 10.2579 5.05835 9.03717 5.05835 9.03717C5.05835 9.03717 2.889 8.09154 2.94222 7.68909C3.9215 7.92331 5.26824 7.66799 5.26824 7.66799C5.26824 7.66799 3.74636 5.23455 3.9007 5.05359C4.13267 5.35424 5.95654 6.62453 5.95654 6.62453C5.95654 6.62453 6.08886 4.45946 6.48138 3.72949C6.52846 4.24476 7.07938 6.5777 7.07938 6.5777C7.07938 6.5777 8.18689 5.10017 8.80159 5.10017C8.53159 5.54652 7.89226 7.50722 7.89226 7.50722C7.89226 7.50722 9.48559 7.47379 10.0913 7.8714C9.35754 8.01056 8.07201 8.87106 8.07201 8.87106C8.07201 8.87106 9.7463 10.5645 9.59365 10.917C8.69472 10.3307 7.65545 10.1343 7.65545 10.1343C7.65545 10.1343 7.94271 12.4909 7.71051 13.0239C7.48405 12.2394 6.63227 10.5771 6.63227 10.5771Z",
    fill: "#FFD018",
    stroke: "#F19900",
    strokeOpacity: 0.98,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53598 9.47966C6.93293 9.47966 7.25473 9.05059 7.25473 8.52132C7.25473 7.99205 6.93293 7.56299 6.53598 7.56299C6.13903 7.56299 5.81723 7.99205 5.81723 8.52132C5.81723 9.05059 6.13903 9.47966 6.53598 9.47966Z",
    fill: "#FFD018",
    stroke: "#F19900",
    strokeOpacity: 0.98,
    strokeWidth: 0.25
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2757_5856)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2757_5856",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUyu);
export default __webpack_public_path__ + "static/media/UYU.6f0e227efa2fc5e154df588bb4c0151d.svg";
export { ForwardRef as ReactComponent };